import { CldImage, CldImageProps } from 'next-cloudinary'
import isString from 'lodash-es/isString'
import type { ExperienceImage } from '@/types'

type CroppedCloudinaryImageProps = Omit<CldImageProps, 'src'> & {
  src: string | ExperienceImage
}

const CroppedCloudinaryImage = ({
  src,
  ...props
}: CroppedCloudinaryImageProps) => {
  if (!src) {
    return null
  }

  if (isString(src)) {
    return <CldImage src={src} {...props} />
  }

  // Focal point path: use CSS object-position instead of server-side crop
  if (src.focal_point) {
    const { crop: _crop, style: existingStyle, ...restProps } = props
    return (
      <CldImage
        src={src.public_id}
        style={{
          ...existingStyle,
          objectFit: 'cover',
          objectPosition: `${src.focal_point.x}% ${src.focal_point.y}%`,
        }}
        {...restProps}
      />
    )
  }

  // Legacy crop coordinates path
  if (src.coordinates?.custom?.[0]) {
    const [x, y, cropWidth, cropHeight] = src.coordinates.custom[0]
    return (
      <CldImage
        src={src.public_id}
        crop={{
          type: 'crop',
          x,
          y,
          width: cropWidth,
          height: cropHeight,
        }}
        {...props}
      />
    )
  }

  return <CldImage src={src.public_id} {...props} />
}

export default CroppedCloudinaryImage
